import { base } from '@App/dicts/pathes'

export class Lib {
    langs = base('lib/languages')
    countries = base('lib/countries')
    writerRoles = base('lib/writer-roles')
    akaTitleTypes = base('lib/aka-title-types')
}
